import React from 'react'

const SocialIcon = ({icon}) => {
return (
    <div className='rounded-[100px] bg-tint p-[6px]'>
        {icon}
    </div>
)
}

export default SocialIcon;